<template>
  <page>
    <list-table group="staff" />
  </page>
</template>

<script>
import Page from "../../components/Page";
import ListTable from "../../components/group-management/ListTable";

export default {
  name: "StaffGroupList",
  components: { ListTable, Page }
};
</script>

<style scoped></style>
